"use strict";

angular.module("imagetrend.components").directive("paginationList", [
    function() {
        return {
            restrict: "AE",
            replace: true,
            scope: {
                numPerPage: "=?",
                currentPage: "=?",
                length: "=?"
            },
            //?^someDirective : Pass someDirective controller if available on one of parent elements to linking function. If not, pass null.
            require: "?^hlpList",
            templateUrl: "templates/list/pagination/pagination.html",
            link: function(scope, elem, attrs, ctrl) {
                scope.perPages = [
                    { id: 10, name: 10 },
                    { id: 15, name: 15 },
                    { id: 20, name: 20 },
                    { id: 25, name: 25 },
                    { id: 50, name: 50 },
                    { id: 100, name: 100 },
                    { id: 250, name: 250 }
                ];

                scope.numOfPages = function(length) {
                    return Math.ceil(length / scope.numPerPage) - 1;
                };

                if (ctrl) {
                    scope.setCurrentPage = ctrl.pageChanged;

                    scope.setPerPage = ctrl.perPageChanged;
                } else {
                    scope.setCurrentPage = function (page) {
                        scope.currentPage = page;
                    };
                    scope.setPerPage = function (perPage) {
                        scope.numPerPage = perPage;
                        scope.currentPage = 0;
                    };
                }

                scope.$watch("length + numPerPage", function () {
                    //Recalculate the number of pages when the total records changes or when the number of records per page changes
                    scope.pages = [];

                    if (scope.length > 0) {
                        var i = 0;
                        for (i = 0; i <= scope.numOfPages(scope.length); i++) {
                            scope.pages.push({ id: i, name: i + 1 });
                        }
                    } else {
                        scope.pages.push({ id: 0, name: 0 });
                    }
                    scope.currentPage = 0;
                });
            }
        };
    }
]);
